<!-- 政府 -->
<template>
  <div class="page_html">
    <banner
      :title="title"
      :subtitle="subtitle"
    />
    <div
      v-for="item in government"
      :key="item.id"
      :class="{ 'bg': item.hasBg }"
    >
      <div class="costs">
        <p class="sub_title">
          {{ item.title }}
        </p>
        <div class="content_S">
          <div>
            {{ item.content }}
          </div>
          <div
            v-if="item.hasImg1"
            class="hasImg"
          >
            <img
              src="@/assets/solution/government/zu11.png"
              alt=""
            >
          </div>
          <div
            v-if="item.hasImg2"
            class="hasImg"
          >
            <img
              src="@/assets/solution/government/zu12.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>

    <Lists :values="values" />
  </div>
</template>
<script>
import banner from '@/views/solution/components/banner.vue'
import Lists from '@/views/solution/components/lists.vue'
export default {
  name: 'Government',
  components: {
    banner,
    Lists
  },
  data() {
    return {
      title: '安全隔离解决方案',
      subtitle: '---政府行业应用案例',
      government: [
        {
          id: 1,
          title: '项目背景',
          content: '为促进工作进度，保证工作效率，政府开展网上审批业务，允许公众通过互联网提交服务申请并提交相关审核资料。该政府网络分为政务内网和政务外网两部分，审批业务服务器部署在政务内网涉密区内，数据到达政务内网后，需要提交到涉密区中的服务器，进行申请和审核。',
          hasImg1: 'true'
        },
        {
          id: 2,
          title: '问题与挑战',
          content: '如果允许访问者通过Web服务器直接向核心服务器发起数据访问请求和文件提交，则黑客可能穿透防火墙的保护直接侵入服务器，修改审批数据，甚至入侵涉密区服务器，窃取机密文件及信息，从而严重威胁到政府机密信息。如何正常提供电子政务应用的同时，保障政府部门涉密信息的安全成为不可忽视的安全问题。',
          hasBg: true
        },
        {
          id: 3,
          title: '解决方案',
          content: '针对以上需求，在政府行业政务内网和政务外网之间部署安全隔离与信息交换系统，在涉密网络与政务内网间部署光单向安全隔离数据自动导入系统，如下图：',
          hasImg2: 'true'
        }
      ],
      values: [
        {
          id: 1,
          title: '安全隔离，保证网络安全',
          src: require('@/assets/solution/government/waiguanzidingyi.png'),
          content: '光单向安全隔离数据自动导入系统在内外主机系统间采用专有协议，阻断网络连接，不仅使得信息网络的抗攻击能力大大增强，而且有效地防范了信息外泄事件的发生 '
        },
        {
          id: 2,
          title: '采用光为传输介质，误码率低',
          src: require('@/assets/solution/government/keshihuaguanli.png'),
          content: '网闸A、B网主机间通过光为传输介质，具有信号强度高，频率集中等特点，不会有任何光信号衰减，所有误码率低。'
        },
        {
          id: 3,
          title: '提供无反馈信号的单向数据通道',
          src: require('@/assets/solution/government/gongdanchuli.png'),
          content: '在传统的全双工通讯中只选择一个方向的线路，所以也称为信息流的单向技术。SFP 光模块作为传输接口，可以实现彻底的单向安全数据通路，即从硬件上彻底保证了单向性，保证涉密网数据不能外流。 '
        },
        {
          id: 4,
          title: '不完整数据”全面报警机制',
          src: require('@/assets/solution/government/chixushengji.png'),
          content: ' 主机发现不完整或丢失的文件，通过主机蜂鸣器发出铃声告警、通过日志进行告警、通过GUI界面进行告警等多种告警机制。'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .costs {
    width: 100%;
    padding-top: 78px;
    padding-bottom: 100px;

    .sub_title {
      margin-bottom: 75px;
    }

    .content_S {
      width: 70%;
      margin: 0 auto;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      line-height: 40px;

      div {
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
      }

      .hasSubTitle {
        font-size: 24px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
      }

      .hasImg {
        width: 100%;
        height: 450px;
        margin-top: 48px;

        img {
          width: 100%;
        }
      }
    }
  }

  .bg {
    background: #FAFBFF;
  }

}

@media screen and (min-width: 1200px) and (max-width: 1350px) {
  .page_html .costs .content_S div{
    font-size: 20px;
  }
  .value .value_list .title {
    font-size: 18px;
    margin: 20px 25px 20px;
  }

  .value {
    width: 85% !important;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1500px) {

  .value {
    width: 80% !important;
  }

  .page_html .costs .content_S div{
     font-size: 22px;
  }
  .value .value_list .title {
    font-size: 22px;
    margin: 20px 25px 20px;
  }

  .page_html .contents .stereoscopic .stereoscopicLists .stereoscopicList .protect {
    width: 300px !important;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px) {
  .value {
    width: 75% !important;
  }

  .value .value_list .title {
    font-size: 22px;
    margin: 20px 25px 20px;
  }
}

@media screen and (min-width: 2000px) and (max-width: 2560px) {
  .page_html .costs .content_S .hasImg {
    height: 680px;
  }
}
</style>
